import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useState } from "react";
import { AppContext } from "./../../lib/Context";

const CustomEvent = ({ event }) => {
  const [open, setOpen] = useState(false);
  const { userData } = useContext(AppContext);

  const toggleTooltip = (value) => {
    if (!value) {
      setTimeout(() => setOpen(false), 150);
    } else {
      setOpen(true);
    }
  };

  const commonTextStyle = {
    fontSize: "0.85rem",
    fontFamily: "Roboto",
    lineHeight: 1.6,
    color: "#333",
  };

  const renderInsideView = () => (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onMouseEnter={() => toggleTooltip(true)}
      onMouseLeave={() => toggleTooltip(false)}
      onTouchStart={() => toggleTooltip(true)}
      sx={{
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      <Typography
        variant="body2"
        fontWeight={500}
        noWrap
        color={"priamry.main"}
      >
        {event?.title}
      </Typography>
    </Stack>
  );

  const renderTooltipView = () => (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        bgcolor={"primary.main"}
        color={"white"}
      >
        <Typography fontSize="0.9rem" fontWeight={600}>
          📋 Details
        </Typography>
      </Stack>

      <Stack p={2} spacing={1.2}>
        {userData?.designation === "Admin" && (
          <Typography {...commonTextStyle}>
            <strong>Agent:</strong> {event?.title}
          </Typography>
        )}

        <Typography {...commonTextStyle}>
          <strong>Date:</strong> {moment(event.offDate).format("DD.MM.YY")}
        </Typography>

        <Typography {...commonTextStyle}>
          <strong>Reason:</strong> {event?.reason}
        </Typography>
      </Stack>
    </Box>
  );

  return (
    <Tooltip
      open={open}
      title={renderTooltipView()}
      onClose={() => toggleTooltip(false)}
      onOpen={() => toggleTooltip(true)}
      disableHoverListener
      disableTouchListener
      placement="top"
      PopperProps={{
        sx: {
          zIndex: 1500,
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            overflow: "hidden",
            minWidth: "320px",
            maxWidth: "420px",
          },
        },
      }}
    >
      <Box>{renderInsideView()}</Box>
    </Tooltip>
  );
};

export default CustomEvent;
